import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createSlots as _createSlots } from "vue";
const _hoisted_1 = { class: "small text-muted" };
const _hoisted_2 = {
    key: 0,
    class: "sticky-top-20 forms__nav-view"
};
const _hoisted_3 = { class: "d-block d-lg-none" };
const _hoisted_4 = { class: "mt-2 mb-1" };
const _hoisted_5 = {
    class: "row fw-bold border-bottom-dashed pt-2 pb-2",
    style: { "border-bottom-style": "dotted" }
};
const _hoisted_6 = { class: "col-8" };
const _hoisted_7 = { class: "col-4 text-end" };
const _hoisted_8 = { class: "alert alert-danger mt-2 mb-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_portal = _resolveComponent("portal");
    const _component_g_ozg_nav_item = _resolveComponent("g-ozg-nav-item");
    const _component_g_content_page = _resolveComponent("g-content-page");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_portal, {
            to: "command-bar",
            order: 900
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", null, [
                    _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.refresh()))
                    }, _toDisplayString(_ctx.$tc('client.Common.Refresh')), 1)
                ])
            ]),
            _: 1
        }),
        _createVNode(_component_g_content_page, null, _createSlots({
            title: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, " Antrag: " + _toDisplayString(_ctx.process.processNumber) + ", " + _toDisplayString(_ctx.process.description), 1)
            ]),
            _: 2
        }, [
            (_ctx.schema && _ctx.pages && _ctx.pages.length > 0 && _ctx.processId)
                ? {
                    name: "sidebar",
                    fn: _withCtx(() => [
                        (_ctx.pages)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
                                    return (_openBlock(), _createBlock(_component_g_ozg_nav_item, {
                                        page: page,
                                        "current-page": _ctx.currentPage,
                                        key: page.name
                                    }, null, 8, ["page", "current-page"]));
                                }), 128))
                            ]))
                            : _createCommentVNode("", true)
                    ])
                }
                : undefined,
            (_ctx.schema && _ctx.pages && _ctx.pages.length > 0 && _ctx.processId)
                ? {
                    name: "content",
                    fn: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("button", {
                                    class: "btn btn-outline-secondary w-100 btn-sm",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.onElementCommand('show-mobile-nav')))
                                }, "Navigation")
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.currentPage?.title), 1),
                            _createElementVNode("div", _hoisted_7, " Seite " + _toDisplayString(_ctx.currentPageNumber) + " von " + _toDisplayString(_ctx.totalPageNumber), 1)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allMessages, (message) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(message.text), 1));
                        }), 256)),
                        (_ctx.currentPage)
                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$forms.componentPageName(_ctx.currentPage?.pageType)), {
                                key: 0,
                                process: _ctx.process,
                                schema: _ctx.schema,
                                data: _ctx.data,
                                page: _ctx.currentPage,
                                onCommand: _ctx.onElementCommand
                            }, null, 8, ["process", "schema", "data", "page", "onCommand"]))
                            : _createCommentVNode("", true)
                    ])
                }
                : undefined
        ]), 1024)
    ], 64));
}
